import React from 'react';

const Copyright = (props) => <p className={props.textClass}>Copyrights &copy; 2021 Stuck Veskovic | Powered by <a className={props.linkClass} href="https://siteplaza.org" target="_blank" rel="noreferrer">Site Plaza</a></p>


export default Copyright;
